import styled from 'styled-components';
import { CouponClient } from 'types';

export const ProductTileLoadingContainer = styled.div`
  min-height: 375px;
  border-radius: ${({ theme }) => theme.borderRadius};
  background: ${({ theme }) => theme.palette.white};
`;

export const LoadingProductImage = styled.div`
  max-width: 300px;
  height: 355px;
  position: relative;
  margin: 0 auto;
  padding-top: 5%;
  cursor: pointer;
`;

export const ProductTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: auto;
  align-items: stretch;
  position: relative;
  cursor: pointer;
  height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius};
  background: ${({ theme }) => theme.palette.white};

  ${({ theme }) => theme.breakpoints.down('md')} {
    .quickAddToCart {
      transform: translateY(0%);
      visibility: visible;
    }
  }

  &:hover {
    .bookmark {
      opacity: 1;
    }
    .quickAddToCart {
      margin-bottom: 3%;
      transform: translateY(0%);
      visibility: visible;
    }
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.125);
  }
`;

export const ImageWrapper = styled.div`
  padding-top: 50px;
`;

export const ProductImage = styled.div`
  max-width: 255px;
  height: 200px;
  position: relative;
  margin: 0 auto;
  padding-top: 5%;
  cursor: pointer;
  margin-bottom: 20px;
`;

export const ProductDetails = styled.div`
  position: relative;
  font-size: 1.1rem;
  /* min-height: 65px; */
  padding-bottom: 10px;
`;

export const ProductTitle = styled.div`
  font-weight: 500;
  font-size: 1rem;
  margin-left: 3%;
  margin-right: 3%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* word-break: break-all; */
  /* min-height: 20px; */
  line-height: 1.5rem;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
  padding: 3% 0 3% 3%;
  gap: 10px;
`;

export const ProductPrice = styled.div<{ $isDiscount?: boolean }>`
  color: rgba(103, 103, 103, 1);
  text-decoration: none;
  margin-left: 0;

  ${({ $isDiscount }) =>
    $isDiscount &&
    `
        text-decoration: line-through;
        color: rgba(103, 103, 103, 0.5);
    `}
`;

export const ProductPriceWithRedeemPoint = styled.div`
  display: flex;
  color: rgba(103, 103, 103, 1);
  align-items: center;
  > :nth-child(1) {
    margin-left: 3px;
  }
  > :nth-child(2) {
    margin-left: 5px;
    font-size: 0.95rem;
  }
`;

export const HelpText = styled.div`
  color: rgba(103, 103, 103, 1);
  text-decoration: none;
  margin-left: 0px;
  font-size: 0.95rem;
`;

export const DiscountedPrice = styled(ProductPrice)`
  font-weight: 500;
`;

export const Bookmarked = styled.div<{ isBookmarked?: boolean }>`
  width: 25px;
  height: 25px;
  right: 5%;
  top: 5%;
  position: absolute;
  z-index: 2;

  opacity: ${({ isBookmarked }) => (isBookmarked ? 1 : 0)};
  transition: opacity 0.3s linear;
  cursor: pointer;
`;

export const QuickAddToCart = styled.div`
  ${({ theme }) => theme.breakpoints.down('md')} {
    background-color: unset;
    padding: 5% 0%;
  }

  visibility: hidden;
  background: rgba(242, 242, 242, 1);
  border-radius: ${({ theme }) => theme.borderRadius};
  position: absolute;
  bottom: 0;
  width: 95%;
  padding: 6% 0;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 400;
  z-index: 2;

  div:first-of-type {
    padding: 2%;
  }

  left: 0;
  right: 0;
  margin: 0 auto;
  transform: translateY(10%);
  transition: transform 300ms;
`;

export const ButtonWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
`;

export const DiscountRibbon = styled.div`
  color: #fff;
  font-size: 0.9rem;
  background: #388e3c;
  padding: 4px 30px 4px 10px;
  margin-top: 10px;
  position: absolute;
  z-index: 5;
  &::after {
    content: '';
    width: 0;
    height: 0;
    top: 0;
    position: absolute;
    right: 0;
    border-right: 13px solid #fff;
    border-top: 13px solid transparent;
    border-bottom: 13px solid transparent;
    z-index: 1;
  }
`;

export const RedeemContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  margin: 4% 3% 9% 3%;

  border-radius: 50px;
  background: rgba(0, 154, 206, 1);
  box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.2);

  * {
    color: white;
  }
`;

export const RedeemText = styled.div`
  font-weight: bolder;
  font-size: 0.8rem;
`;

/*
  RedeemSpace is used to reserve space for the badge, preventing CSS layout issues.
  Without this setup, the height of the product tile would not align properly.
*/
export const RedeemSpace = styled(RedeemContainer)`
  visibility: hidden;
  &::after {
    content: '\\00a0 ';
  }
`;
export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const PricesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
